import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ListPageHeader } from '@/components/common/ListPageHeader'
import { DictionaryPanel } from './DictionaryPanel'
import { banksConfig } from './configs/banksConfig'
import { actionTypesConfig } from './configs/actionTypesConfig'
import { documentTypesConfig } from './configs/documentTypesConfig'
import { regionsConfig } from './configs/regionsConfig'

export function DictionariesPage() {
  return (
    <div className="flex flex-col w-full">
      <ListPageHeader
        title="Słowniki"
        subtitle="Banki, typy akcji i typy dokumentów zadań."
      />
      <div className="p-4">
        <Tabs defaultValue="banks">
          <TabsList>
            <TabsTrigger value="banks">Banki</TabsTrigger>
            <TabsTrigger value="action-types">Typy akcji</TabsTrigger>
            <TabsTrigger value="document-types">Typy dokumentów</TabsTrigger>
            <TabsTrigger value="regions">Regiony</TabsTrigger>
          </TabsList>

          <TabsContent value="banks">
            <div className="max-w-2xl mt-4">
              <DictionaryPanel {...banksConfig} />
            </div>
          </TabsContent>

          <TabsContent value="action-types">
            <div className="max-w-2xl mt-4">
              <DictionaryPanel {...actionTypesConfig} />
            </div>
          </TabsContent>

          <TabsContent value="document-types">
            <div className="max-w-2xl mt-4">
              <DictionaryPanel {...documentTypesConfig} />
            </div>
          </TabsContent>

          <TabsContent value="regions">
            <div className="max-w-2xl mt-4">
              <DictionaryPanel {...regionsConfig} />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}
